<template>
  <div>
    <pc-block class="pc-doc-request">
      <pc-request-document :backend-errors="backendErrors" @request="requestDocuments" />
    </pc-block>
    <pc-block>
      <pc-documents-archive :update="updateArchive"></pc-documents-archive>
    </pc-block>
  </div>
</template>

<script>
import PcBlock from '@/components/views/PrivateCabinet/PcBlock'
import PcRequestDocument from '@/components/views/PrivateCabinet/PcRequestDocument'
import PcDocumentsArchive from '@/components/views/PrivateCabinet/PcDocumentsArchive'
import {api} from '@/api/api'
export default {
  name: 'PcDocumentRequest',
  components: {PcDocumentsArchive, PcRequestDocument, PcBlock},
  data() {
    return {
      updateArchive: false,
      backendErrors: {
      }
    }
  },
  mounted(){
   this.updateArchiveList()
  },
  methods: {

    async requestDocuments(formData, callback){
      try {
        const {data} = await api.cabinet.requestDocument(formData)
        this.updateArchiveList()
        callback()

      }catch(err){
        if (err.response?.data._error_code === 'BackOfficeError') {
          this.$toast.error(this.$t('notifications.something-went-wrong'))
        }
        this.backendErrors = err.response.data
      }
    },
    updateArchiveList() {
      this.updateArchive = true
      setTimeout(() => {this.updateArchive = false}, 0)
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";

.pc-doc-request {
  max-width: 715px;
  @media (max-width:$desktop) {
    max-width: 100%;
  }
}
</style>
